"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToastContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useToastContextValues_unstable;
    }
});
function useToastContextValues_unstable(state) {
    const { backgroundAppearance } = state;
    return {
        backgroundAppearance
    };
}
